module.exports = __webpack_public_path__ + "img/了解更多-二维码-2.123d706a.jpg";